"use client";

import { useEffect, useRef } from "react";
import { incrementPageViews } from "@/actions/analytics";

export default function ViewTracker({ slug }: { slug: string }) {
    const hasIncremented = useRef(false);

    useEffect(() => {
        if (hasIncremented.current) return;
        hasIncremented.current = true;
        
        incrementPageViews(slug).catch(() => {
            // Silently fail if tracking fails to avoid breaking client side
        });
    }, [slug]);

    return null;
}
